import { FC } from 'react';

type StatusVariant =
  | 'completed'
  | 'running'
  | 'failed'
  | 'pending'
  | 'not-started'
  | string;

type TaskStatusBadgeProps = {
  status: StatusVariant;
  className?: string;
  variant?: 'solid' | 'transparent';
  size?: 'normal' | 'small' | 'x-small';
};

export const TaskStatusBadge: FC<TaskStatusBadgeProps> = ({
  status,
  className = '',
  variant = 'transparent',
  size = 'normal',
}) => {
  const getStatusColor = (status: StatusVariant): string => {
    switch (status) {
      case 'completed':
        return '#4caf50'; // Green
      case 'running':
        return '#2196f3'; // Blue
      case 'failed':
        return '#f44336'; // Red
      case 'pending':
        return '#ff9800'; // Orange
      case 'not-started':
        return '#757575'; // Gray
      default:
        return '#555'; // Default dark gray
    }
  };

  const formattedStatus = status.replace(/-/g, ' ');
  const statusColor = getStatusColor(status);

  const backgroundColor =
    variant === 'transparent'
      ? `${statusColor}33` // Semi-transparent (33 is 20% opacity in hex)
      : statusColor;

  const textColor = variant === 'transparent' ? statusColor : 'white';

  const getSizeClasses = () => {
    switch (size) {
      case 'small':
        return 'text-xs px-2 py-1';
      case 'x-small':
        return 'text-xs px-1 py-0';
      default:
        return 'text-sm px-2 py-1';
    }
  };

  return (
    <span
      className={`border-round ${getSizeClasses()} ${className}`}
      style={{
        backgroundColor,
        color: textColor,
        fontSize: size === 'x-small' ? '0.65rem' : undefined,
      }}
    >
      {formattedStatus}
    </span>
  );
};

export default TaskStatusBadge;
